import {RouteProp, useRoute} from '@react-navigation/core';
import {useDispatch, useSelector} from 'Provider';
import React, {useCallback} from 'react';

import LinkAffiliateAccount from 'components/LinkAffiliateAccount';

import {AffiliateActions} from 'store/affiliate/affiliate.reducer';
import {
  getAccountDetailsStateMapSelector,
  partnerListSelector,
} from 'store/affiliate/affiliate.selectors';

type ParamList = {LinkAffiliateAccount: {partnerId: string}};

const ConnectedLinkAffiliateAccount = () => {
  const partnerList = useSelector(partnerListSelector);

  const route = useRoute<RouteProp<ParamList, 'LinkAffiliateAccount'>>();
  const partnerId = route?.params?.partnerId || '';
  const partner = partnerList.find(p => p.leapProperties[0].code === partnerId);
  const dispatch = useDispatch();
  const accountDetailsStateMap = useSelector(getAccountDetailsStateMapSelector);

  const onLinkPress = useCallback(
    accountNumber => {
      dispatch(
        AffiliateActions.initiateMatchTier({
          partnerAccountID: accountNumber,
          partnerID: partner?.leapProperties[0].code || '',
        })
      );
    },
    [dispatch, partner?.leapProperties]
  );

  return (
    <LinkAffiliateAccount
      onLinkPress={onLinkPress}
      partner={partner}
      apiError={
        accountDetailsStateMap?.[partnerId]?.initiateMatchTierResponseError
      }
      apiState={accountDetailsStateMap?.[partnerId]?.initiateMatchTier}
    />
  );
};

export default ConnectedLinkAffiliateAccount;
